module.exports = vendors_ru_0bacddc97755c4270ce6;